import { useParams } from "react-router-dom";
import {
  MapIcon,
  // SearchClearIcon,
  SearchIcon,
} from "../../../../assets/svgIcons";
import { useSellModeFilters } from "../../../../hooks/useSellModeFilters";
import primaryComponents from "../../../primaryComponents";
import styles from "./styles.module.scss";
import { useGetInfo } from "../../../../hooks/useGetInfo";
import { truncateString } from "../../../../helpers";
import { useEffect, useState } from "react";

export const SellModeSearch = () => {
  const { search, filterBySearch } = useSellModeFilters();
  const { store_id } = useParams();
  const { getStoreInfo } = useGetInfo();
  const storeDetails = getStoreInfo(store_id);
  const [searchValue, setSearchValue] = useState(search.get("query") || "");

  // keep the input in sync with the url (e.g. cleared after a
  // scanned product is successfully added to cart)
  useEffect(() => {
    setSearchValue(search.get("query") || "");
  }, [search]);

  return (
    <>
      <div className={styles.sellModeSearch}>
        <primaryComponents.SearchField
          borderColor="#ad91f5"
          value={searchValue}
          scanIcon={
            <span className={styles.scanIcon}>
              <span
                className={`smallest-text-size white--text ${styles.category}`}
              >
                <MapIcon
                  className="font-weight-bold white--text mr-1"
                  style={{ fontSize: "20px" }}
                />
                <span className="font-weight-bold">
                  {truncateString(storeDetails?.name, 25)}
                </span>
              </span>
              <SearchIcon />
            </span>
          }
          showsearchBtn={false}
          showClearBtn={true}
          isDebounce={true}
          triggerOnInput={false}
          placeholder="Search items by barcode scanner or name"
          useBorderImage={true}
          useControlledValue={true}
          style={{ borderRadius: "8px !important" }}
          trigger={(val) => {
            filterBySearch(val);
          }}
        />
      </div>
    </>
  );
};
